import './style.scss';

import { forwardRef, Ref } from 'react';
import { useOutletContext } from 'react-router-dom';

import { OutletContext } from '@/model';

interface IInputEmail {
	placeholder?: string;
}

export const InputEmail = forwardRef(
	({ placeholder, ...props }: IInputEmail, ref: Ref<HTMLInputElement>) => {
		const { versionId }: OutletContext = useOutletContext();
		return (
			<input
				className={`pandora__input pandora__input--v${versionId}`}
				ref={ref}
				{...props}
				placeholder={placeholder}
			/>
		);
	}
);
